export default __webpack_public_path__ + "static/media/36I-102631_-15547_0.385699f8.jpg";